import { runtimeEnv, useSafeLogout } from '@worknet/app-core';
import { WsClientToServerEvents, WsServerToClientEvents } from '@worknet/models';
import { io, Socket, SocketOptions } from 'socket.io-client';

export type TypeSocket = Socket<WsServerToClientEvents, WsClientToServerEvents>;

export function createSocketIo(
  authHeaders: Record<string, string>,
  getToken?: () => Promise<string>
): TypeSocket {
  const wsBaseUrl = `${runtimeEnv.apiBaseUrl}/ws`;
  const url = new URL(`${wsBaseUrl}/socket.io`);
  const logout = useSafeLogout();

  const onAuth: SocketOptions['auth'] = async (setAuthPayload) => {
    const token = await getToken?.().catch(logout);
    setAuthPayload({ ...authHeaders, authorization: token ? `Bearer ${token}` : undefined });
  };

  const socket = io(url.origin, {
    reconnectionAttempts: 5,
    transports: ['websocket', 'polling'],
    upgrade: true,
    withCredentials: true,
    path: url.pathname,
    auth: onAuth,
  });

  socket.on('connect_error', (err) => {
    console.error('connect_error', {
      ...err,
      message: err.message,
      name: err.name,
      transports: socket.io.opts.transports,
    });
    socket.io.opts.transports = ['polling', 'websocket'];
  });

  socket.io.on('reconnect_failed', () => {
    console.error('reconnect_failed', { transports: socket.io.opts.transports });
  });

  return socket;
}
